import uuidV4 from "uuid/v4";
export const getUniqId = () => {
    return uuidV4();
};